import { ListItemAvatar, ListItemAvatarProps } from "@mui/material";
import React from "react";

export type WcListItemAvatarProps = ListItemAvatarProps;

export const WcListItemAvatar = ({ children, ...props }: WcListItemAvatarProps) => <ListItemAvatar {...props}>{children}</ListItemAvatar>;
